var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContinuous(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 10.92",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ef5323;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "refresh-20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    className: "cls-1",
    d: "M3.31,2.77a3.85,3.85,0,0,1,5.38,0A4.14,4.14,0,0,1,9.77,4.85l1.54-.23A5.13,5.13,0,0,0,9.85,1.69a5.45,5.45,0,0,0-7.62,0L.54,0,0,4.92l4.92-.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    className: "cls-1",
    d: "M12,6l-4.92.54L8.69,8.15a3.83,3.83,0,0,1-5.38,0A4.11,4.11,0,0,1,2.23,6.08L.69,6.31A5.1,5.1,0,0,0,2.15,9.23a5.19,5.19,0,0,0,3.77,1.54A5.36,5.36,0,0,0,9.69,9.23l1.69,1.69Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContinuous);
export default __webpack_public_path__ + "static/media/continuous.cfefff3e7bc335e23848fc586f041906.svg";
export { ForwardRef as ReactComponent };